<template>
  <VRegisterApp
    name="ticket"
    @mounted="handleMounted"
    @next="handleNext"
    :workbench="workbench"
    :checkout="checkout"
  >
    <el-form ref="formRefs" :model="form" :scroll-to-error="true">
      <!--
        年级只做前端筛选，不参与票种代码、价格和库存计算。
        当前仅对活动名称精确等于 2026-2027 External Community Clubs T1 时启用。
      -->
      <el-form-item v-if="enableGradeFilter" class="grade-filter-form-item">
        <el-card class="grade-filter-card" shadow="never">
          <div class="grade-filter__header">
            <div>
              <div class="grade-filter__title">
                {{ ["选择学生年级（可多选）", "Select Student Grade(s)"][$language] }}
              </div>
              <div class="grade-filter__description">
                {{
                  [
                    "可同时选择多个年级，系统将显示适用所选年级的活动。",
                    "Select one or more grades. Activities matching any selected grade will be shown.",
                  ][$language]
                }}
              </div>
            </div>
            <div class="grade-filter__actions">
              <span>
                {{ ["已选择", "Selected"][$language] }}
                {{ selectedGrades.length }}
              </span>
              <el-button type="primary" plain @click="selectAllGrades">
                {{ ["全选", "Select all"][$language] }}
              </el-button>
              <el-button
                type="primary"
                plain
                :disabled="selectedGrades.length === 0"
                @click="clearGrades"
              >
                {{ ["清空", "Clear"][$language] }}
              </el-button>
            </div>
          </div>

          <el-checkbox-group
            v-model="selectedGrades"
            class="grade-filter__options"
            @change="handleGradeFilterChange"
          >
            <el-checkbox
              v-for="grade in gradeOptions"
              :key="grade.code"
              :label="grade.code"
              class="grade-filter__option"
            >
              {{ grade.label }}
            </el-checkbox>
          </el-checkbox-group>

          <!-- <div class="grade-filter__tip">
            <span>i</span>
            {{
              [
                "年级仅用于筛选；活动票代码、价格、剩余库存及购买数量仍按原票种独立管理。",
                "Grades are filters only. Ticket code, price, stock and quantity remain independently managed.",
              ][$language]
            }}
          </div> -->
        </el-card>
      </el-form-item>

      <el-form-item
        v-for="it in visibleTicketGroups"
        :key="it.id"
        :prop="it.id"
        :rules="[
          {
            validator: (rule, value, callback) =>
              ticketValidator(it.id, rule, value, callback),
          },
        ]"
      >
        <el-card class="ticket">
          <template #header v-if="it.children && it.children.length&& it.children.filter(x=>!x.isPriceEnd).length">
            <div class="ticket__header" @click.stop="toggleGroup(it.id)">
              <div class="title">
                <!-- <i class="dot"></i> -->
                 <span class="expand-icon">
       <el-icon v-if="expandedGroups[it.id]"><Minus /></el-icon>
        <el-icon v-else><Plus /></el-icon>
      </span>
                <span>{{ it.name.split("|")[$language] || it.name }}</span>
              </div>
              <div
                class="description"
                v-if="it.description && it.children && it.children.length"
              >
                {{
                  (
                    it.description.split("|")[$language] ||
                    it.description ||
                    ""
                  ).replaceAll("	", " ")
                }}
              </div>
            </div>
          </template>
          <template v-if="it.children && it.children.length">
            <div class="ticket-item" v-for="c in it.children.filter(x=>!x.isPriceEnd)" :key="c.id"   v-show="expandedGroups[it.id]">
              <div class="title">
                <div class="name">
                  {{ c.name.split("|")[$language] || c.name }}
                </div>
                <div class="extra">
                  <span v-if="!c.amountMode">
                    <span v-if=" c.price==0" style="padding-right: 24px">{{
                    ["免费", "Free"][$language] 
                  }}</span>
                    <span v-else>{{ c.price }}（{{ c.currency }}）</span></span>
                  
                  <span v-else style="padding-right: 24px">{{
                    ["金额", "Amount"][$language]
                  }}</span> 
                  <span class="grey" v-if="pageConfig.config.ShowResidueNumber"
                    >{{ $t(`registration.ticket.quantity`) }} {{ c.quantity }}</span
                  >
                </div>
              </div>
              <div
                class="row description"
                v-if="(c.description || '').replace(/[\s]*/g, '').length > 0"
              >
                {{
                  (c.description.split("|")[$language] || c.description || "").replaceAll(
                    "	",
                    " "
                  )
                }}
              </div>
              <div class="row is--time">
                <div
                  class="time"
                  v-if="!pageConfig.config.HideSaleDate && c.saleStartdate"
                >
                  <span class="grey">{{ $t(`registration.ticket.starttime`) }}</span>
                  <span class="text">{{ c.saleStartdate }}</span>
                </div>
                <div class="time" v-if="!pageConfig.config.HideSaleDate && c.saleEnddate">
                  <span class="grey">{{ $t(`registration.ticket.endtime`) }}</span>
                  <span class="text">{{ c.saleEnddate }}</span>
                </div>
                <div class="time"></div>
              </div>
              <div class="row is--exp">
                <div
                  class="exp"
                  v-if="
                    !pageConfig.config.HideValidDate &&
                    (c.priceStartdate || c.priceEnddate)
                  "
                >
                  <span class="grey">{{ $t(`registration.ticket.expire`) }}</span>
                  <span class="text">{{
                    [c.priceStartdate, c.priceEnddate].filter((x) => x).join(" - ")
                  }}</span>
                </div>
                <div class="exp"></div>
              </div>
              <div class="qty">
                <template v-if="c.isSaleStart">
                  <template v-if="!c.isSaleEnd">
                    <template v-if="c.amountMode">
                      <el-input-number
                        v-if="c.amountMode"
                        class="is--number-account"
                        @change="handleQty(c.code)"
                        size="large"
                        v-model="form[c.code].num"
                        :min="c.min"
                        :max="c.max"
                        :value-clear="0"
                      />

                      <span style="padding-left: 8px">RMB</span>
                    </template>
                    <el-input-number
                      v-else
                      class="is--number-qty"
                      @change="handleQty(c.code)"
                      size="large"
                      v-model="form[c.code].num"
                      :min="c.min"
                      :max="c.max"
                      :value-clear="0"
                    />
                  </template>
                  <span v-else style="color: #f00">{{
                    ["已售罄", "Sold Out"][$language]
                  }}</span>
                </template>
                <span v-else style="color: #f00">{{
                  ["未开始", "Not Start"][$language]
                }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="ticket-item" >
              <div class="title">
                <div class="name">
                  {{ it.name.split("|")[$language] || it.name }}
                </div>
                <div class="extra">
                  <span v-if="!it.amountMode">
                    <span v-if=" it.price==0" style="padding-right: 24px">{{
                    ["免费", "Free"][$language] 
                  }}</span>
                    <span v-else>{{ it.price }}（{{ it.currency }}）</span></span>
                  <span v-else style="padding-right: 24px">{{
                    ["金额", "Amount"][$language]
                  }}</span>
                  <span class="grey" v-if="pageConfig.config.ShowResidueNumber"
                    >{{ $t(`registration.ticket.quantity`) }} {{ it.quantity }}</span
                  >
                </div>
              </div>
              <div
                class="row description"
                v-if="(it.description || '').replace(/[\s]*/g, '').length > 0"
              >
                {{
                  (
                    it.description.split("|")[$language] ||
                    it.description ||
                    ""
                  ).replaceAll("	", " ")
                }}
              </div>
              <div class="row is--time">
                <div
                  class="time"
                  v-if="!pageConfig.config.HideSaleDate && it.saleStartdate"
                >
                  <span class="grey">{{ $t(`registration.ticket.starttime`) }}</span>
                  <span class="text">{{ it.saleStartdate }}</span>
                </div>
                <div
                  class="time"
                  v-if="!pageConfig.config.HideSaleDate && it.saleEnddate"
                >
                  <span class="grey">{{ $t(`registration.ticket.endtime`) }}</span>
                  <span class="text">{{ it.saleEnddate }}</span>
                </div>
                <div class="time"></div>
              </div>
              <div class="row is--exp">
                <div
                  class="exp"
                  v-if="
                    !pageConfig.config.HideValidDate &&
                    (it.priceStartdate || it.priceEnddate)
                  "
                >
                  <span class="grey">{{ $t(`registration.ticket.expire`) }}</span>
                  <span class="text">{{
                    [it.priceStartdate, it.priceEnddate].filter((x) => x).join(" - ")
                  }}</span>
                </div>
                <div class="exp"></div>
              </div>
              <div class="qty">
                <template v-if="it.isSaleStart">
                  <template v-if="!it.isSaleEnd">
                    <template v-if="it.amountMode">
                      <el-input-number
                        class="is--number-account"
                        @change="handleQty(it.code)"
                        size="large"
                        v-model="form[it.code].num"
                        :min="it.min"
                        :max="it.max"
                        :value-clear="0"
                      />
                      <span style="padding-left: 8px">RMB</span>
                    </template>
                    <el-input-number
                      class="is--number-qty"
                      v-else
                      @change="handleQty(it.code)"
                      size="large"
                      v-model="form[it.code].num"
                      :min="it.min"
                      :max="it.max"
                      :value-clear="0"
                    />
                  </template>
                  <span v-else style="color: #f00">{{
                    ["已售罄", "Sold Out"][$language]
                  }}</span>
                </template>
                <span v-else style="color: #f00">{{
                  ["未开始", "Not Start"][$language]
                }}</span>
              </div>
            </div>
          </template>
        </el-card>
      </el-form-item>

      <el-empty
        v-if="enableGradeFilter && selectedGrades.length === 0"
        :description="
          [
            '请先选择至少一个学生年级',
            'Please select at least one student grade',
          ][$language]
        "
      />
      <el-empty
        v-else-if="enableGradeFilter && visibleTicketGroups.length === 0"
        :description="
          [
            '所选年级暂无可报名活动',
            'No activities are available for the selected grades',
          ][$language]
        "
      />
    </el-form>
    <div v-if="workbench" style="display: flex; justify-content: center; padding: 24px">
      <el-button class="next" type="primary" @click="handleNext">{{
        $t("registration.btn.next")
      }}</el-button>
    </div>
  </VRegisterApp>
</template>

<script setup>
import VRegisterApp from "../app/index.vue";
import { onMounted, ref, nextTick, computed, inject } from "vue";
import { ArrowDown, ArrowUp } from "@element-plus/icons-vue";

import { ticket } from "@/api/registration";
import { ElMessage, ElLoading } from "element-plus";
import { useRouter } from "vue-router";

import { useI18n } from "vue-i18n";

import { useUserStore } from "@/store/modules/user";
import {
 
  Plus,
  Minus
} from "@element-plus/icons-vue";
const props = defineProps({
  workbench: {
    type: Boolean,
    default: false,
  },
  checkout: {
    type: Boolean,
    default: false,
  },
});

const { t, te } = useI18n();

const router = useRouter();
const pageConfig = ref({});
const information = ref({});
const form = ref({});
const formRefs = ref(null);

const $steps = inject("$steps");
const $language = inject("$language");
const $event = inject("$event");
//const $information= inject('$steps')

// 目标活动固定显示 Oak、Y1-Y13，共 14 个年级选项。
const DEFAULT_GRADE_OPTIONS = [
  "Oak",
  "Y1",
  "Y2",
  "Y3",
  "Y4",
  "Y5",
  "Y6",
  "Y7",
  "Y8",
  "Y9",
  "Y10",
  "Y11",
  "Y12",
  "Y13",
];

const eventValue = computed(() => $event?.value || $event || {});

const TARGET_GRADE_FILTER_EVENT_NAME =
  "2026-2027 External Community Clubs T1";

// 临时采用活动名称精确匹配，只影响目标活动。
// 兼容 EventName 使用“中文|英文”保存的情况，但不会误匹配 T2 等活动。
const enableGradeFilter = computed(() => {
  const eventName = String(eventValue.value?.EventName || "");
  return eventName
    .split("|")
    .map((name) => name.trim())
    .includes(TARGET_GRADE_FILTER_EVENT_NAME);
});

const gradeOptions = computed(() =>
  DEFAULT_GRADE_OPTIONS.map((grade) => ({ code: grade, label: grade })),
);

// 默认不选，要求报名人先明确选择一个或多个年级。
const selectedGrades = ref([]);

const normalizeGradeCodes = (value) => {
  if (Array.isArray(value)) {
    return value.map((x) => String(x).trim()).filter((x) => x);
  }
  if (typeof value === "string") {
    return value.split(/[,，;；|]/).map((x) => x.trim()).filter((x) => x);
  }
  return [];
};

// 临时兼容旧数据：从票种名称解析 Oak、Y1-Y3、Y2-7、Y2 and above 等。
// 正式方案应由后台直接为每个具体票种返回 gradeCodes 数组。
const parseGradeCodesFromName = (name = "") => {
  const source = String(name).replaceAll("|", " ");
  const grades = new Set();

  if (/Pre[-\s]?Nursery/i.test(source)) grades.add("Pre-Nursery");
  const withoutPreNursery = source.replace(/Pre[-\s]?Nursery/gi, "");
  if (/\bNursery\b/i.test(withoutPreNursery)) grades.add("Nursery");
  if (/\bOak\b/i.test(source)) grades.add("Oak");

  const addYearRange = (start, end) => {
    const from = Math.max(1, Number(start));
    const to = Math.min(13, Number(end));
    for (let year = from; year <= to; year += 1) {
      grades.add(`Y${year}`);
    }
  };

  for (const match of source.matchAll(/Y(\d{1,2})\s*(?:-|–|—|~|to)\s*Y?(\d{1,2})/gi)) {
    addYearRange(match[1], match[2]);
  }
  for (const match of source.matchAll(/Y(\d{1,2})\s*(?:and\s+above|及以上|\+)/gi)) {
    addYearRange(match[1], 13);
  }
  for (const match of source.matchAll(/Y(\d{1,2})/gi)) {
    const year = Number(match[1]);
    if (year >= 1 && year <= 13) grades.add(`Y${year}`);
  }

  return [...grades];
};

const getTicketGradeCodes = (ticketItem) => {
  // 推荐字段：gradeCodes: ["Y1", "Y2"]
  const explicit = normalizeGradeCodes(
    ticketItem.gradeCodes || ticketItem.GradeCodes || ticketItem.grades,
  );
  return explicit.length ? explicit : parseGradeCodesFromName(ticketItem.name);
};

const isTicketMatched = (ticketItem) => {
  if (!enableGradeFilter.value) return true;
  if (selectedGrades.value.length === 0) return false;

  const ticketGrades = getTicketGradeCodes(ticketItem);
  // 没有设置任何年级的票种视作通用票种。
  if (ticketGrades.length === 0) return true;
  return ticketGrades.some((grade) => selectedGrades.value.includes(grade));
};

// 保留原来的“星期大类 -> 具体票种”结构，只过滤 children。
const visibleTicketGroups = computed(() => {
  const groups = (pageConfig.value.tickets || []).filter((x) => !x.isPriceEnd);
  if (!enableGradeFilter.value) return groups;

  return groups.reduce((result, group) => {
    if (group.children && group.children.length) {
      const children = group.children.filter(
        (ticketItem) => !ticketItem.isPriceEnd && isTicketMatched(ticketItem),
      );
      if (children.length) result.push({ ...group, children });
    } else if (isTicketMatched(group)) {
      result.push(group);
    }
    return result;
  }, []);
});

const getVisibleLeafTickets = () => {
  const result = [];
  for (const group of visibleTicketGroups.value) {
    if (group.children && group.children.length) {
      result.push(...group.children);
    } else {
      result.push(group);
    }
  }
  return result;
};

// 切换筛选条件后，把已经隐藏的“本次新选数量”清零，避免提交不可见票种。
const clearHiddenTicketQuantities = () => {
  const visibleCodes = new Set(getVisibleLeafTickets().map((ticketItem) => ticketItem.code));
  const allTickets = [];
  for (const group of pageConfig.value.tickets || []) {
    if (group.children && group.children.length) allTickets.push(...group.children);
    else allTickets.push(group);
  }

  for (const ticketItem of allTickets) {
    if (!visibleCodes.has(ticketItem.code) && form.value[ticketItem.code]) {
      form.value[ticketItem.code].num = ticketItem.amountMode ? null : 0;
    }
  }
};

const handleGradeFilterChange = () => {
  clearHiddenTicketQuantities();
};

const selectAllGrades = () => {
  selectedGrades.value = gradeOptions.value.map((grade) => grade.code);
  handleGradeFilterChange();
};

const clearGrades = () => {
  selectedGrades.value = [];
  clearHiddenTicketQuantities();
};

const current = computed(() => {
  for (var g of $steps.value) {
    if (g.Name == "ticket") {
      return g;
    }
  }
  return null;
});
// 新增：记录每个大类的展开状态，默认全部展开
const expandedGroups = ref({});

//切换展开状态的方法
const toggleGroup = (groupId) => {
  expandedGroups.value[groupId] = !expandedGroups.value[groupId];
};
const handleMounted = (val) => {
  pageConfig.value = val.pageConfig;
  information.value = val.information;
  let orders = {};
  let tickets = [];

  //展开所有的票
  for (var it of pageConfig.value.tickets) {
    if (it.children && it.children.length > 0) {
      tickets.push(...it.children);
    } else {
      tickets.push(it);
    }
  }
  let done = false;
  //按代码生成订单格式
  for (var c of tickets) {
    console.log(c.minOrder, c.maxOrder, c.num);
    let x = {
      num: 0,
      done: 0,
      approval: c.requireApproval,
      min: c.minOrder,
      max: c.maxOrder,
    };
    //修正错误数据
    if (c.mandatory) {
      if (!(x.min && x.min > 0)) {
        x.min = 1;
      }
    } else {
      x.min = 0;
    }
    if (!(x.max && x.max > 0)) {
      //如果max错误
      x.max = 10;
    }
    if (x.max < x.min) {
      //最大值小于最小值
      x.max = x.min;
    }
    if (x.min > x.quantity) {
      x.min = x.quantity;
    }
    if (x.max > x.quantity) {
      x.max = x.quantity;
    }
    orders[c.code] = x;
  }
  for (var g of information.value.orders || []) {
    //计算当前用户每一种票购买的数量
    if (g.Status.toLocaleLowerCase() === "success") {
      done = true;
    }
    if (orders.hasOwnProperty(g.TicketCode)) {
      if (
        g.Status.toLocaleLowerCase() === "ready" &&
        ((!orders[g.TicketCode].approval && (g.OrderStatus || "") === "") ||
          (orders[g.TicketCode].approval &&
            (g.OrderStatus || "").toLocaleLowerCase() === "approval"))
      ) {
        orders[g.TicketCode].done = orders[g.TicketCode].done + g.Number;
      } else {
        orders[g.TicketCode].done = orders[g.TicketCode].done + g.Number;
      }
    }
  }
  console.log(
    "-----------------------------",
    $event,
    $event.value?.Config?.HideBuyAgain,
    done
  );

  //如果当前限制买一个票种
  //console.log($event)
  if ($event.Config.PurchaseSingle === true) {
    //如果有存在，
    for (var c in orders) {
      //c.mandatory=false;
      orders[c].min = 0;
    }
    var doneKey = null;
    for (var c in orders) {
      if (orders[c].done > 0) {
        doneKey = c;
      }
    }
    if (doneKey) {
      for (var c in orders) {
        if (c != doneKey) {
          orders[c].limited = true;
        }
      }
    }
  }

  //重新计算最大可购买数量
  for (var c of tickets) {
    c.min = Math.min(c.quantity, Math.max(0, c.minOrder - orders[c.code].done));
    c.max = Math.min(
      c.quantity,
      Math.max(0, Math.min(c.maxOrder, c.quantity) - orders[c.code].done)
    );
    console.log(c);
    //console.log(c,'quantity='+c.quantity,'done='+orders[c.code].done,c.min ,c.max )
    if (orders[c.code].limited === true) {
      //如果是单一购票逻辑，有订单就不能下其他了
      c.min = 0;
      c.max = 0;
    }
    if ($event.Config.PurchaseSingle === true) {
      //
      //单一购买
      c.min = 0;
      c.minOrder2 = c.minOrder;
      c.minOrder = 0;
      c.mandatory = false;
    }
    c.num = c.min;
    if (!c.sale) {
      c.min = 0;
      c.max = 0;
      c.num = 0;
    }
  }

  for (var c of tickets) {
    if (c.amountMode) {
      orders[c.code].num = null;
    }
  }
  form.value = orders;

  console.log("information", tickets);

  if ($event?.Config?.HideBuyAgain === true && done) {
    //
    if (props.workbench) {
      router.push({ name: "personalcenter-confirmation" });
    } else {
      router.push({ name: "confirmation" });
    }
    return;
  }

  nextTick(() => {
    //el-input__inner
    var nums = document.querySelectorAll(".is--number-qty");
    for (var i = 0, len = nums.length; i < len; i++) {
      nums[i].querySelector(".el-input__inner")?.setAttribute("readonly", "readonly");
    }
  });
};

const handleNext = (val) => {
  // 年级筛选启用时，必须至少选择一个年级；否则页面没有票种表单项，
  // 单靠 el-form 的票种校验无法拦截。
  if (enableGradeFilter.value && selectedGrades.value.length === 0) {
    ElMessage({
      message: [
        "请至少选择一个学生年级",
        "Please select at least one student grade",
      ][$language.value],
      type: "error",
    });
    return;
  }

  formRefs.value.validate(async (valid, fields) => {
    if (!valid) {
      for (var g in fields) {
        ElMessage({
          message: fields[g][0].message,
          type: "error",
        });
        break;
      }
      return;
    }
    let val = {};
    for (var g in form.value) {
      val[g] = form.value[g].num;
    }
    const loadingInstance = ElLoading.service({ fullscreen: true });
    try {
      const { data } = await ticket(val);
      const { setToken } = useUserStore();
      setToken({ uid: data.uid });
      //
      //
      loadingInstance.close();
      if (props.checkout) {
        router.push({ name: "checkout-payment" });
        return;
      }
      if (props.workbench) {
        //个人中心
        //读取所有数据
        let steps = information.value.steps;
        if (steps.indexOf("colleague") >= 0) {
          router.push({ name: "personalcenter-colleague" });
        } else {
          router.push({ name: "personalcenter-order" });
        }
      } else {
        router.push({ name: data.to });
      }
    } catch (e) {
      //ElMessage({ message: e.msg || '提交出错', type: 'success' })
    }
    loadingInstance.close();
  });
};

const handleQty____ = (code) => {
  if ($event.Config.PurchaseSingle === true) {
    if (form.value[code].limited === true) {
      form.value[code].num = 0;
    } else {
      //
      for (var c in form.value) {
        if (c !== code && form.value[c].done > 0) {
          form.value[code].num = 0;
          break;
        }
      }
      for (var c in form.value) {
        //
        if (c !== code && form.value[c].done === 0) {
          form.value[c].num = 0;
          console.log(form.value[c]);
        }
      }
    }
  }
};

const handleQty = (code) => {
  
  if ($event.Config.PurchaseSingle === true) {
    if (form.value[code].limited === true) {
      form.value[code].num = 0;
    } else {
      //
      console.log(code, pageConfig.value.tickets, form.value);
      //
      {
        let isGroupFind = false;
        for (var g of pageConfig.value.tickets) {
          if (g.children && g.children) {
            for (var t of g.children) {
              // console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',t)
              if (t.code === code) {
                isGroupFind = true;
                console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx");
                break;
              }
            }
            if (isGroupFind) {
              for (var t of g.children) {
                if (t.code !== code && form.value[t.code].done === 0) {
                  form.value[t.code].num = 0;
                }
              }
            }
          }
        }
        if (isGroupFind) {
          return;
        }
      }
      for (var c in form.value) {
        if (c !== code && form.value[c].done > 0) {
          form.value[code].num = 0;
          break;
        }
      }
      for (var c in form.value) {
        //
        if (c !== code && form.value[c].done === 0) {
          form.value[c].num = 0;
          console.log(form.value[c]);
        }
      }
    }
  }

// ----- BSN的13个年级报名活动需要组内只能选一种票类型，互斥 start -----
if ($event.EventName.includes('External Community Clubs')) {
  // 找到当前票种所属的大类
  let parentGroup = null;
  for (let g of pageConfig.value.tickets) {
    if (g.children && g.children.length) {
      const found = g.children.find(c => c.code === code);
      if (found) {
        parentGroup = g;
        break;
      }
    }
  }
  
  if (parentGroup) {
    // 当前被修改的票种数量
    const currentVal = form.value[code].num;
    
    // 只有当数量 > 0 时，才需要清空同组其他票种
    if (currentVal > 0) {
      parentGroup.children.forEach(c => {
        if (c.code !== code && form.value[c.code]) {
          // 将其他小类数量设为 0（注意：此时它们的 min 已为 0，不会触发 input-number 限制）
          form.value[c.code].num = 0;
        }
      });
    }
  }
}
  // ----- 组内互斥 end -----
};

const ticketValidator = (id, rule, value, callback) => {
  if (enableGradeFilter.value && selectedGrades.value.length === 0) {
    callback(
      new Error(["请至少选择一个学生年级", "Please select at least one student grade"][$language.value]),
    );
    return;
  }

  // 只校验当前年级筛选后可见的具体票种，隐藏票种不参与必选校验。
  const tickets = getVisibleLeafTickets();
  if ($event.Config.PurchaseSingle === true) {
    var mandatory = false;
    for (var g of tickets) {
      if (g.sale && g.minOrder2 && g.minOrder2 > 0) {
        mandatory = true;
      }
    }
    if (mandatory) {
      var isOk = false;
      for (var g of tickets) {
        console.log(g, form.value[g.code].num + form.value[g.code].done);
        const selectedNumber =
          form.value[g.code].num + form.value[g.code].done;

        if (enableGradeFilter.value) {
          // 目标活动必须实际选择至少一种票。
          if (selectedNumber > 0) {
            isOk = true;
            break;
          }
        } else {
          // 其他旧活动保持原来的校验行为不变。
          if (selectedNumber >= 0) {
            isOk = true;
            break;
          }
        }
      }
      if (!isOk) {
        callback(new Error([`请购票`, "Ticket required"][$language.value]));
        return;
      }
    }
  } else {
    for (var g of tickets) {
      if (g.sale && g.minOrder > 0) {
        if (form.value[g.code].num + form.value[g.code].done < g.minOrder) {
          callback(new Error(t(`registration.form.required`, { title: g.name })));
          return;
        }
      }
    }
  }
  callback();
};
</script>

<style lang="scss" scoped>
.el-form {
  :deep() {
    .el-form-item__error {
      display: none;
    }
  }
}

.grade-filter-form-item {
  margin-bottom: 16px;
  :deep(.el-form-item__content) {
    display: block;
  }
}

.grade-filter-card {
  border: 1px solid var(--el-border-color-light);
  border-radius: 8px;
  :deep(.el-card__body) {
    padding: 20px;
  }
}

.grade-filter__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.grade-filter__title {
  color: #363f5e;
  font-size: 15px;
  font-weight: bold;
  line-height: 22px;
}

.grade-filter__description {
  margin-top: 4px;
  color: #999;
  font-size: 12px;
  line-height: 18px;
}

.grade-filter__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  color: #999;
  font-size: 12px;
  :deep(.el-button + .el-button) {
    margin-left: 0;
  }
  :deep(.el-button) {
    min-width: 54px;
    height: 30px;
    padding: 0 12px;
    border-radius: 3px;
    font-size: 12px;
  }
}

.grade-filter__options {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 8px;
  :deep(.el-checkbox) {
    width: 100%;
    min-height: 42px;
    margin-right: 0;
    padding: 8px 10px;
    display: flex;
    align-items: center;
    border: 1px solid var(--el-border-color-light);
    border-radius: 4px;
    background: #fff;
    box-sizing: border-box;
    transition: border-color 0.15s ease, background-color 0.15s ease;
  }
  :deep(.el-checkbox:hover),
  :deep(.el-checkbox.is-checked) {
    border-color: var(--el-color-primary);
    background: var(--el-color-primary-light-9);
  }
  :deep(.el-checkbox__input) {
    flex: 0 0 auto;
  }
  :deep(.el-checkbox__inner) {
    width: 16px;
    height: 16px;
    border-radius: 3px;
  }
  :deep(.el-checkbox__label) {
    padding-left: 8px;
    color: #363f5e;
    font-size: 12px;
    font-weight: 600;
  }
  :deep(.el-checkbox.is-checked .el-checkbox__label) {
    color: var(--el-color-primary);
  }
}

.grade-filter__tip {
  margin-top: 14px;
  padding: 9px 12px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border-radius: 4px;
  background: var(--el-color-primary-light-9);
  color: #667;
  font-size: 12px;
  line-height: 18px;
  > span {
    flex: 0 0 auto;
    width: 17px;
    height: 17px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--el-color-primary);
    border-radius: 50%;
    color: var(--el-color-primary);
    font-family: serif;
    font-weight: bold;
  }
}
.ticket {
  padding: 0;
  margin-bottom: 0px;
  box-shadow: none;
  border-width: 0;
  width: 100%;
  .ticket__header {
  cursor: pointer;
   color: var(--el-color-primary); 
  .expand-icon {
    margin-right: 8px;
    display: inline-flex;
    align-items: center;
   
    .el-icon {
      font-size: 16px;
      color: var(--el-color-primary);
    }
  }
}
  .description {
    color: #999;
    white-space: pre;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  :deep() {
    > .el-card__header {
      padding: 12px 20px 12px 20px;
      color: #363f5e;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom-width: 0;
      .title {
        line-height: 20px;
        font-weight: bold;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .dot {
          width: 6px;
          height: 6px;
          background-color: var(--el-color-primary);
          border-radius: 50%;
          display: block;
          margin-right: 8px;
        }
        .el-icon {
          margin-left: 8px;
          color: var(--el-color-primary);
        }
      }
    }
    > .el-card__body {
      padding: 0 20px;
      .el-card {
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  &.is--children {
    background: rgba(241, 244, 249, 0.68);
    border-radius: 12px;
    :deep() {
      > .el-card__header {
        padding: 12px 20px 0 20px;
      }
      > .el-card__body {
        padding: 12px 24px 12px 24px;
      }
    }
  }
}
.el-input-number {
  &.is--number-qty {
    width: 150px;
    :deep() {
      .el-input-number__increase,
      .el-input-number__decrease,
      .el-input__inner {
        border: solid 1px var(--el-border-color-light);
        background-color: #fff;
        border-radius: 4px;
        box-sizing: border-box;
        font-size: 16px;
        .el-icon {
          color: var(--el-color-primary);
        }
      }
      .el-input__wrapper {
        box-shadow: none;
        background-color: transparent;
        margin: 0 3px;
        padding-left: 42px;
        padding-right: 42px;
        display: flex;
        justify-content: center;
        align-items: center;
        .el-input__inner {
          line-height: var(--el-input-inner-height);
          font-weight: bold;
          color: var(--el-color-primary);
        }
      }
    }
  }
  &.is--number-account {
    width: 100px;
    :deep() {
      .el-input-number__increase,
      .el-input-number__decrease {
        display: none;
      }
    }
  }
}
.ticket-item {
  padding: 0;
  margin-bottom: 8px;
  box-shadow: none;
  border-width: 0;
  background: rgba(241, 244, 249, 0.68);
  border-radius: 12px;
  padding: 12px 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  position: relative;
  > div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 22px;
    margin-right: 22px;
    min-height: 22px;
    margin-top: 4px;
    width: 100%;
    &:last-child {
      margin-bottom: 0;
    }

    &.title {
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      .name {
        color: #363f5e;
        font-size: 14px;
        font-weight: bold;
      }
    }
    .time {
      margin-right: 12px;
    }
    span {
      &.grey {
        color: #999999;
      }
      &.text {
        color: #333333;
      }
    }
    &.is--exp {
      min-height: 40px;
    }

    &.qty {
      position: absolute;
      right: 0;
      bottom: 12px;
      width: auto;
    }
  }
}

@media screen and (max-width: 760px) {
  .grade-filter__header {
    flex-direction: column;
  }
  .grade-filter__actions {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .grade-filter__options {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .ticket-item {
    > div {
      &.title {
        flex-direction: column;
        justify-content: flex-start;
        .name {
          color: #363f5e;
          font-size: 14px;
          font-weight: bold;
          width: 100%;
          margin-bottom: 6px;
        }
        .extra {
          text-align: right;
          width: 100%;
        }
      }
    }
  }
  .row {
    &.is--time {
      flex-wrap: wrap;
      .time {
        width: 100%;
        margin-right: 0;
      }
    }
  }
  .qty {
    right: 0 !important;
  }
}
.el-input-number {
  &.is--number-qty {
    :deep() {
      .el-input-number__decrease.is-disabled,
      .el-input-number__increase.is-disabled {
        cursor: not-allowed;

        background-color: var(--el-color-info-light-9);
        border-color: var(--el-color-info-light-8);
        .el-icon {
          color: var(--el-color-info-light-5);
        }
      }
    }
  }
}
</style>
